export default __webpack_public_path__ + "static/media/bronze-wheel.67a1992d.png";